import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { DELETE_EVENT_ACTION_TYPE, DELETE_MASTER_ACTION_TYPE, deleteEventMasterUrl, deleteMasterUrl, deletePromoCodeUrl, GET_EVENT_DETAILS_ACTION_TYPE, GET_EVENT_LIST_ACTION_TYPE, GET_MASTER_DETAILS_ACTION_TYPE, GET_MASTER_LIST_ACTION_TYPE, getEventMasterDetailsUrl, getEventMasterListUrl, getMasterDetailsUrl, getMasterListUrl, getPromoCodeDetailsUrl, getPromoCodeListUrl, headers, INSERT_MASTER_ACTION_TYPE, INSERT_UPDATE_EVENT_ACTION_TYPE, INSERT_UPDATE_MASTER_ACTION_TYPE, insertPromoCodeUrl, insertUpdateEventMasterUrl, insertUpdateMasterUrl, insertUpdatemasterUrl, insertUpdatePromoCodeUrl, UPDATE_MASTER_ACTION_TYPE, updatePromoCodeUrl, } from "../../utils/constants"

export const get_eventMaster_list_action = (Title, isActive,isAdmin) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            Title: Title ? Title : null,
            isActive: isActive ? isActive : 1,
            isAdmin:isAdmin?isAdmin:0
        }
        const res = await axiosGet(getEventMasterListUrl, mapdata, headers);

        dispatch({
            type: GET_EVENT_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_eventMaster_details_action = (EventID, isMemberDashboard) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            EventID: EventID,
            isMemberDashboard: isMemberDashboard
        }
        const res = await axiosGet(getEventMasterDetailsUrl, mapdata, headers);
        dispatch({
            type: GET_EVENT_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertUpdate_eventMaster_action = (EventID, Title, URL, EventFromDate, EventToDate, Address, Description,
    filename, filetype, formfile, FilePath, SeqNo, PriceInr, PriceUsd, isMemberDashboard, isDraft, checkedMemberList) => async (dispatch) => {
        try {
            const mapdata = {
                UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
                EventID: EventID, Title: Title, URL: URL,
                EventFromDate: EventFromDate != "" ? EventFromDate : null,
                EventToDate: EventToDate != "" ? EventToDate : null,
                Address: Address ? Address : '',
                Description: Description,
                filename: filename, filetype: filetype, formfile: formfile, FilePath: FilePath,
                SeqNo: SeqNo,
                PriceInr: PriceInr ? PriceInr : '',
                PriceUsd: PriceUsd ? PriceUsd : '',
                isMemberDashboard: isMemberDashboard ? isMemberDashboard : 0,
                isDraft: isDraft ? isDraft : 0,
                checkedMemberList: checkedMemberList
            }

            console.log("insertUpdate_eventMaster_action res", mapdata)
            const res = await axiosPost(insertUpdateEventMasterUrl, mapdata, headers);

            dispatch({
                type: INSERT_UPDATE_EVENT_ACTION_TYPE,
                payload: res,
            });

            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    }

export const delete_eventMaster_action = (EventID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            EventID: EventID
        }
        const res = await axiosGet(deleteEventMasterUrl, mapdata, headers);
        dispatch({
            type: DELETE_EVENT_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};